import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('GATE_CARD_APPLY');
export const gateCardApply = dataModuleActions.dataRequest;
export const gateCardApplySuccess = dataModuleActions.dataSuccess;
export const gateCardApplyError = dataModuleActions.dataError;
export const resetGateCardApply = dataModuleActions.dataReset;
